import React from 'react';
import { ChevronRight, Package } from 'lucide-react';
import { InventoryItem } from '../hooks/useInventory';
interface InventoryCardProps {
  item: InventoryItem;
  onClick: () => void;
}
export function InventoryCard({
  item,
  onClick
}: InventoryCardProps) {
  const stockPercentage = Math.round(item.quantity / item.maxQuantity * 100);
  // Magical status colors
  const statusColor = item.status === 'Critical' ? 'bg-[#8B0000] shadow-[0_0_8px_#8B0000]' : item.status === 'Warning' ? 'bg-[#D4A017] shadow-[0_0_8px_#D4A017]' : 'bg-[#2D5A3D] shadow-[0_0_8px_#2D5A3D]';
  const barColor = stockPercentage < 30 ? 'bg-[#8B0000]' : stockPercentage < 50 ? 'bg-[#D4A017]' : 'bg-[#2D5A3D]';
  return <div onClick={onClick} className="group relative bg-[#FFFDF5] border border-[#C9A227]/40 rounded-xl p-4 flex items-center transition-all duration-300 hover:border-[#C9A227] hover:shadow-[0_4px_12px_rgba(201,162,39,0.15)] active:scale-[0.98] cursor-pointer" data-id="element-16">
      {/* Corner Flourishes */}
      <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-[#C9A227] rounded-tl-sm opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-17" />
      <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-[#C9A227] rounded-tr-sm opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-18" />
      <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-[#C9A227] rounded-bl-sm opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-19" />
      <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-[#C9A227] rounded-br-sm opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-20" />

      <div className="h-14 w-14 bg-[#F5F0E1] border border-[#C9A227]/30 rounded-lg flex items-center justify-center mr-4 overflow-hidden shrink-0 shadow-inner" data-id="element-21">
        {item.photoUrl ? <img src={item.photoUrl} alt={item.name} className="w-full h-full object-cover sepia-[0.3]" data-id="element-22" /> : <Package className="w-6 h-6 text-[#722F37]/60" data-id="element-23" />}
      </div>

      <div className="flex-1 min-w-0" data-id="element-24">
        <div className="flex items-center gap-2 mb-1" data-id="element-25">
          <h3 className="font-cinzel font-bold text-[#2C2C2C] truncate text-base" data-id="element-26">
            {item.name}
          </h3>
          <span className={`w-2 h-2 rounded-full shrink-0 ${statusColor}`} data-id="element-27" />
        </div>
        <div className="flex items-center gap-2 text-sm text-[#555]" data-id="element-28">
          <span className="font-medium text-[#722F37]" data-id="element-29">
            {item.quantity} {item.unit}
          </span>
          <span className="text-[#C9A227]" data-id="element-30">•</span>
          <span className="truncate text-xs italic font-serif" data-id="element-31">
            {item.category}
          </span>
        </div>

        {/* Magical Stock bar */}
        <div className="h-1.5 bg-[#F5F0E1] border border-[#C9A227]/20 rounded-full overflow-hidden w-24 mt-2" data-id="element-32">
          <div className={`h-full rounded-full transition-all duration-500 ${barColor}`} style={{
          width: `${stockPercentage}%`
        }} data-id="element-33" />
        </div>
      </div>

      <ChevronRight className="w-5 h-5 text-[#C9A227] ml-2 shrink-0 opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-34" />
    </div>;
}